import { useEffect } from 'react'
import ReportSection from '../../components/ReportSection'
import { Stack } from 'ui/baseComponents/Stack'
import { Link } from 'ui/baseComponents/Link'
import { SECTION_TITLES, VIDEO_LINKS } from '../../consts'
import {
  APPLE_LINK_USE_THE_HEALTH_APP,
  // FALL_RISK_LEVEL_COLORS,
  MOBILITY_METRICS,
} from './consts'
import useMobilityAggregate from 'ui/hooks/summaryAggregates/useMobilityAggregate'
// import useFallRisk from 'ui/hooks/useFallRisk'
import { Text } from 'ui/baseComponents/Text'
import { Table } from 'ui/baseComponents/Table'
import ReportMetricTrend from '../../components/ReportMetricTrend'
// import ReportMetricTrendIcon from '../../components/ReportMetricTrendIcon'
import {
  // getFallRiskIconVariant,
  getMobilityMetricProps,
} from 'ui/clinicianScreens/Patient/Report/sections/Mobility/helpers'
import { useSectionTitle } from 'ui/clinicianScreens/Patient/Report/sectionTitles'
import { useReportTranslation } from 'utilities/i18n'

// const FallRiskTrend = ({ iconVariant, direction, prevFallRiskLevel }) => {
//   const { t } = useReportTranslation()
//
//   if (!iconVariant) {
//     return (
//       <Text variant="body16">
//         {!prevFallRiskLevel
//           ? t('report.common.noDataPrevious')
//           : t('report.common.noChange')}
//       </Text>
//     )
//   }
//
//   return (
//     <Stack alignItems="center" direction="row" spacing={0.5}>
//       <ReportMetricTrendIcon direction={direction} variant={iconVariant} />
//       <Text variant="body16">
//         {iconVariant === 'worse'
//           ? t('report.mobility.fallRiskIncreased')
//           : t('report.mobility.fallRiskDecreased')}
//       </Text>
//     </Stack>
//   )
// }

const ReportSectionMobility = ({
  onLoadStart = () => {},
  onLoadEnd = () => {},
  hiddenSections,
  startDate,
  endDate,
  prevStartDate,
  prevEndDate,
  addToHasDataSet,
  removeFromHasDataSet,
  isClinicianReport,
  hasDataSet,
}) => {
  const title = SECTION_TITLES.MOBILITY
  const sectionTitle = useSectionTitle()
  const { t } = useReportTranslation()
  const { data, hasData, isLoading } = useMobilityAggregate(startDate, endDate)
  const { data: prevData, isLoading: prevIsLoading } = useMobilityAggregate(
    prevStartDate,
    prevEndDate,
  )
  // const { fallRiskLevel, isLoading: fallRiskLoading } = useFallRisk(
  //   startDate,
  //   endDate,
  // )
  // const { fallRiskLevel: prevFallRiskLevel, isLoading: prevFallRiskLoading } =
  //   useFallRisk(prevStartDate, prevEndDate)

  const { stepLength, walkingSpeed, doubleSupportPercentage } = data || {}
  const {
    stepLength: prevStepLength,
    walkingSpeed: prevWalkingSpeed,
    doubleSupportPercentage: prevDoubleSupportPercentage,
  } = prevData || {}
  const loading = isLoading || prevIsLoading // || fallRiskLoading || prevFallRiskLoading

  useEffect(() => {
    if (loading) {
      onLoadStart(title)
    } else {
      onLoadEnd(title)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    if (!isLoading && data) {
      hasData ? addToHasDataSet(title) : removeFromHasDataSet(title)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, hasData])

  const stepLengthMetricProps = getMobilityMetricProps(
    stepLength,
    prevStepLength,
    t(MOBILITY_METRICS.stepLength.titleKey),
    false,
    t,
  )
  const walkingSpeedMetricProps = getMobilityMetricProps(
    walkingSpeed,
    prevWalkingSpeed,
    t(MOBILITY_METRICS.walkingSpeed.titleKey),
    false,
    t,
  )
  const doubleSupportPercentageMetricProps = getMobilityMetricProps(
    doubleSupportPercentage,
    prevDoubleSupportPercentage,
    t(MOBILITY_METRICS.doubleSupport.titleKey),
    true,
    t,
  )

  const mobilityRowsData = [
    {
      title: t(MOBILITY_METRICS.stepLength.titleKey),
      data: stepLengthMetricProps,
      goal: t('report.mobility.goalStepLength'),
    },
    {
      title: t(MOBILITY_METRICS.walkingSpeed.titleKey),
      data: walkingSpeedMetricProps,
      goal: t('report.mobility.goalWalkingSpeed'),
    },
    {
      title: t(MOBILITY_METRICS.doubleSupport.titleKey),
      data: doubleSupportPercentageMetricProps,
      goal: t('report.mobility.goalDoubleSupport'),
    },
  ]

  const formattedMobilityRows = mobilityRowsData.map((row) => {
    const { title, data, goal } = row
    const { value, trend, trendLabel, noPrevData, iconVariant } = data
    return [
      {
        key: `mobility-cell-metric-${title}`,
        value: <Text variant="body16B">{title}</Text>,
      },
      {
        key: `mobility-cell-value-${title}`,
        value: <Text variant="body16B">{value}</Text>,
      },
      {
        key: `mobility-cell-diff-${title}`,
        value: (
          <ReportMetricTrend
            {...{
              value,
              trend,
              trendLabel,
              noPrevData,
              iconVariant,
            }}
          />
        ),
      },
      {
        key: `mobility-cell-goal-${title}`,
        value: <Text variant="body16">{goal}</Text>,
      },
    ]
  })

  // const fallRiskIconVariant = getFallRiskIconVariant(
  //   fallRiskLevel,
  //   prevFallRiskLevel,
  // )
  // const fallRiskDirection =
  //   fallRiskIconVariant === 'worse'
  //     ? 'up'
  //     : fallRiskIconVariant === 'better'
  //     ? 'down'
  //     : null

  // const fallRiskRow = fallRiskLevel
  //   ? [
  //       [
  //         {
  //           key: 'mobility-cell-metric-fall-risk',
  //           value: (
  //             <Text variant="body16B">{t('report.mobility.fallRisk')}</Text>
  //           ),
  //         },
  //         {
  //           key: 'mobility-cell-value-fall-risk',
  //           value: (
  //             <Text
  //               variant="body16B"
  //               sx={{ color: FALL_RISK_LEVEL_COLORS[fallRiskLevel] }}
  //               data-cy="fall-risk-level"
  //             >
  //               {t(`report.mobility.fallRiskLevel${fallRiskLevel}`)}
  //             </Text>
  //           ),
  //         },
  //         {
  //           key: 'mobility-cell-diff-fall-risk',
  //           value: (
  //             <span data-cy="fall-risk-trend">
  //               <FallRiskTrend
  //                 iconVariant={fallRiskIconVariant}
  //                 direction={fallRiskDirection}
  //                 prevFallRiskLevel={prevFallRiskLevel}
  //               />
  //             </span>
  //           ),
  //         },
  //         {
  //           key: 'mobility-cell-goal-fall-risk',
  //           value: (
  //             <Text variant="body16">{t('report.mobility.goalFallRisk')}</Text>
  //           ),
  //         },
  //       ],
  //     ]
  //   : []

  // const allRows = [...formattedMobilityRows, ...fallRiskRow]
  const allRows = formattedMobilityRows

  const mobilityHeadings = [
    { key: 'mobility-heading-metric', value: '' },
    { key: 'mobility-heading-value', value: '' },
    { key: 'mobility-heading-diff', value: '' },
    { key: 'mobility-heading-goal', value: t('report.mobility.goal') },
  ]

  return (
    <ReportSection
      title={sectionTitle(title)}
      sectionId={title}
      subtitle={t('report.subtitle.mobility')}
      hidden={
        hiddenSections.has(title) ||
        (isClinicianReport && !hasDataSet.has(title))
      }
    >
      <Stack spacing={2}>
        {hasData ? (
          <Table
            rows={allRows}
            headings={mobilityHeadings}
            tableCellProps={{ size: 'small' }}
          />
        ) : (
          <Text
            variant="body16"
            component="p"
            data-cy="mobility-section-no-data"
          >
            {t('report.mobility.emptyState')}
          </Text>
        )}
        {!isClinicianReport &&
          (hasData ? (
            <Text variant="body14" component="p" data-cy="mobility-helper">
              {t('report.mobility.helperUnderstandMore')}{' '}
              <Link href={VIDEO_LINKS.whatIsMobility} external underline light>
                {t('report.common.watchOurVideo')}
              </Link>
              .
            </Text>
          ) : (
            <Text
              variant="body14"
              component="p"
              data-cy="mobility-helper-no-data"
            >
              {t('report.mobility.helperEmptyState')}{' '}
              <Link
                href={APPLE_LINK_USE_THE_HEALTH_APP}
                external
                underline
                light
              >
                {t('report.mobility.appleHealthLinkText')}
              </Link>
            </Text>
          ))}
      </Stack>
    </ReportSection>
  )
}

export default ReportSectionMobility
